import { Auth } from 'aws-amplify';
import history from '../history';
import { TrackEvent } from '../utils/AnalyticsUtils';
import UsersClient from '../clients/UsersClient';

export const useLogout = () => {
  const logout = async (
    isTestUser: boolean,
    redirectUrl: string,
    isClient: boolean,
    allSessions = true,
  ) => {
    await Auth.signOut();
    TrackEvent(`Signed Out`, { isTestUser });
    // clients should be redirected to the SignoutRedirectURL internal users have set,
    // whether that is within copilot domain or a marketing site of their choice
    if (isClient) {
      window.location.replace(`/auth/signout?next=${redirectUrl}`);
    } else {
      const endFc = allSessions
        ? UsersClient.endSessions
        : UsersClient.endCurrentSession;
      await endFc();
      history.replace(redirectUrl);
    }
  };
  return logout;
};
